function toggle(event){
  el = document.querySelector(".product-sidebar .product-categories");
  el.classList.toggle("prodCatAppear");
}

function untoggle(event, clicker){
  el = document.querySelector(".product-sidebar .prodCatAppear");
  if(el){
    var isClickInside = ( clicker === event.target);
    if(!isClickInside){
      el.classList.toggle("prodCatAppear");
    }
  }
}

window.onload = function(){
  var clickElements = document.querySelectorAll('.product-sidebar .widget-title');
  for (var i = 0; i < clickElements.length; i++) {
    var clicker = clickElements[i];
    clicker.addEventListener('click', function(){toggle(event)});
    document.addEventListener('click', function(){untoggle(event, clicker)});
  }
}
